<template>

  <section class="px-14 pt-8 sm:pt-0 md-max:pt-0 sm-max:px-5 font-21 md-max:text-base">

    <div class="text-center lg:text-19 text-15" v-html="title"></div>

    <div class=" max-w-2xl m-auto mt-6 px-10 sm-max:px-0">
      <nuxt-img
          class="m-auto"
          loading="lazy"
          width="585"
          height="65"
          :alt="logo1Alt"
          format="webp"
          :src="logo1Src"
      ></nuxt-img>

    </div>



  </section>

</template>


<script setup>

defineProps({
  title: {
    type: String,
    default: 'Free shipping on your first order!'
  },
  logo1Alt: {
    type: String,
    default: 'logos'
  },
  logo1Src: {
    type: String,
    default: '/assets/images/freebag-trust-icons.png'
  }
})


defineBuilderComponent({
    friendlyName: "FreeShipping",
    canHaveChildren: true,
    inputs: [
        {
            name: "title",
            type: "richText",
            defaultValue: "Free shipping on your first order!"
        },
        {
            name: "logo1Alt",
            type: "text",
            defaultValue: "logos"
        },
        {
            name: "logo1Src",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png",
                "svg"
            ],
            defaultValue: "/assets/images/freebag-trust-icons.png",
            required: true
        }
    ]
});
</script>